import React, {useCallback, useEffect, useRef, useState} from 'react';
import {
    Row,
    Col,
    Button,
    Alert,
    CardHeader,
    CardBody,
    Form,
    FormGroup,
    Label,
    Input,
    Card,
    FormFeedback
} from "reactstrap5";
import PropTypes from "prop-types";
import {FormattedMessage, FormattedNumber} from "react-intl";
import iconArrow from "../../../images/modal-icon-arrow.svg";
import classNames from "classnames";
import useFetch from "react-fetch-hook";
import iconStop from "../../../images/modal-icon-stop2.svg";
import parsePhoneNumber from 'libphonenumber-js'

const BasketPage = ({config}) => {

    const invoiceParamRef = useRef(null);
    const paymentMethodRef = useRef(null);
    const [showError, setShowError] = useState(false);
    const [showValidErrors, setShowValidError] = useState(false);
    const [showValidPhoneErrors, setShowValidPhoneError] = useState(false);
    const [invoiceType, setInvoiceType] = useState('person');
    const [paymentMethod, setPaymentMethod] = useState('card');
    const [previousPersonData, setPreviousPersonData] = useState({});
    const [previousCompanyData, setPreviousCompanyData] = useState({});
    const [inited, setInited] = useState(false);
    const [enabledPaymentMethod, setEnabledPaymentMethod] = useState([]);
    const [showDiscountForm, setShowDiscountForm] = useState(false);
    const [requestTriggerValue, setRequestTriggerValue] = useState(0);
    const [invalidDiscountCode, setInvalidDiscountCode] = useState(false);
    const [changePersonData, setChangePersonData] = useState(false);
    const [basketData, setBasketData] = useState(null);
    const discountCodeInput = useRef(null);
    const {data: userBasketData} = useFetch(config.userBasketDataUrl, {
        depends: [requestTriggerValue]
    });

    const nextStep = useCallback((e) => {

        if (e) {
            e.preventDefault();
        }

        setShowError(false);

        if (invoiceType === 'person') {

            let parsePhone = parsePhoneNumber(invoiceParamRef.current?.elements['invoicePhone']?.value, 'CZ');

            if (!parsePhone || !parsePhone.isValid()) {
                setShowValidPhoneError(true);
                invoiceParamRef.current.elements['invoicePhone'].setCustomValidity('invalid');
                return;
            } else {
                setShowValidPhoneError(false);
                invoiceParamRef.current.elements['invoicePhone'].setCustomValidity('');
            }
        }

        if (!invoiceParamRef.current.checkValidity() || !paymentMethodRef.current.checkValidity()) {
            setShowValidError(true);
            return;
        }

        let data = {
            invoiceType: invoiceType,
            paymentMethod: paymentMethod
        }

        if (data.invoiceType === 'person') {
            data.invoiceName = invoiceParamRef.current.elements['invoiceName'].value;
            data.invoicePhone = parsePhoneNumber(invoiceParamRef.current.elements['invoicePhone'].value, 'CZ').formatInternational();
        } else {
            data.school = invoiceParamRef.current.elements['school'].value;
        }

        const body = new URLSearchParams(data);

        fetch(config.saveInvoiceParamUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: body.toString(),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.status) {
                    window.location.href = config.recapitulationUrl;
                } else {
                    setShowError(true);
                }
            })
            .catch((error) => {
                setShowError(true);
            });
    }, [setShowError, invoiceParamRef, paymentMethodRef, paymentMethod, config, invoiceType]);

    const changeInvoiceType = useCallback((value) => {

        if (value !== invoiceType) {
            if (value === 'company') {
                setPreviousPersonData({
                    name: invoiceParamRef.current.elements['invoiceName'].value,
                    phone: invoiceParamRef.current.elements['invoicePhone'].value
                });
            } else {
                if (paymentMethod === 'invoice') {
                    setPaymentMethod('card');
                }

                setPreviousCompanyData({
                    school: invoiceParamRef.current.elements['school'].value
                })
            }

            setInvoiceType(value);
            setShowValidPhoneError(false);
            setShowValidError(false);
            setShowError(false);
            setChangePersonData(false);
        }

    }, [setInvoiceType, invoiceType, setShowError, setShowValidPhoneError, setShowValidError, setPreviousPersonData, setPreviousCompanyData, invoiceParamRef]);



    const {isLoading, data: newBasketData} = useFetch(config.basketDataUrl, {
        depends: [requestTriggerValue]
    });

    useEffect(() => {
        setBasketData(newBasketData);
    }, [newBasketData]);

    useEffect(() => {

        if (!requestTriggerValue) {
            setRequestTriggerValue(1);
        }

    }, [requestTriggerValue, setRequestTriggerValue]);

    const addDiscountCode = useCallback((e) => {

        if (e) {
            e.preventDefault();
        }

        const body = new URLSearchParams({code: discountCodeInput.current.value});

        fetch(config.addDiscountCodeUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: body.toString(),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.status) {
                    setShowDiscountForm(false);
                    setInvalidDiscountCode(false);
                    setRequestTriggerValue(requestTriggerValue + 1);
                } else {
                    setInvalidDiscountCode(true);
                }
            })
            .catch((error) => {
                setInvalidDiscountCode(true);
            });
    }, [setRequestTriggerValue, requestTriggerValue, discountCodeInput, setShowDiscountForm]);

    const removeDiscountCode = useCallback(() => {

        fetch(config.removeDiscountCodeUrl, {
            method: 'GET',
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.status) {
                    setInvalidDiscountCode(false);
                    setRequestTriggerValue(requestTriggerValue + 1);
                }
            });
    }, [setRequestTriggerValue, requestTriggerValue]);

    const removeFromBasket = useCallback((id) => {

        const body = new URLSearchParams({id: id});

        fetch(config.removeFromBasketUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: body.toString(),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.status) {
                    setRequestTriggerValue(requestTriggerValue + 1);

                    const navbarBasketCount = document.getElementById('navbar-basket-count');

                    if (navbarBasketCount) {
                        navbarBasketCount.innerText = parseInt(navbarBasketCount.innerText) - 1;
                    }
                }

                if (data.empty) {
                    window.location.reload();
                }
            });
    }, [setRequestTriggerValue, requestTriggerValue]);

    useEffect(() => {

        if (!userBasketData || !invoiceParamRef) {
            return;
        }

        if (!inited) {
            setInited(true);

            if (userBasketData.setInvoiceType) {
                setInvoiceType(userBasketData.setInvoiceType);
            }

            if (userBasketData.setPaymentMethod) {
                setPaymentMethod(userBasketData.setPaymentMethod);
            }
        }

        if (invoiceType === 'person' && !changePersonData) {

            if (previousPersonData.name) {
                invoiceParamRef.current.elements['invoiceName'].value = previousPersonData.name;
                invoiceParamRef.current.elements['invoiceEmail'].value = userBasketData.email;
                invoiceParamRef.current.elements['invoicePhone'].value = previousPersonData.phone;
            } else {
                invoiceParamRef.current.elements['invoiceName'].value = userBasketData.name;
                invoiceParamRef.current.elements['invoiceEmail'].value = userBasketData.email;
                invoiceParamRef.current.elements['invoicePhone'].value = userBasketData.phone;
            }
        } else if (invoiceType === 'company' && !changePersonData) {
            if (previousCompanyData.school) {
                invoiceParamRef.current.elements['school'].value = previousCompanyData.school;
            }
        }

        if (userBasketData.enabledPayments.indexOf(paymentMethod) === -1) {
            setPaymentMethod(userBasketData.enabledPayments[0]);
        }

        setEnabledPaymentMethod(userBasketData.enabledPayments);

    }, [userBasketData, invoiceParamRef, invoiceType, paymentMethod, enabledPaymentMethod, setPaymentMethod, setEnabledPaymentMethod, inited, setInited, setInvoiceType, changePersonData, previousPersonData, previousCompanyData]);

    return (
        <Row>
            {showValidErrors &&
                <Col xs={{size: 12, order: 2}} lg={{size: 12, order: 0}} className="pt-3 pt-lg-0"><Alert color="danger">
                    <FormattedMessage defaultMessage="Nejsou vyplněné všechny povinné parametry"/>
                </Alert></Col>}
            {showValidPhoneErrors &&
                <Col xs={{size: 12, order: 2}} lg={{size: 12, order: 0}} className="pt-3 pt-lg-0"><Alert color="danger">
                    <FormattedMessage defaultMessage="Telefonní číslo není ve správném formátu"/>
                </Alert></Col>}
            <Col xs={{size: 12, order: 1}} lg={6} xxl={8} className="p-0 px-lg-2">
                <Card className="rounded-0 rounded-lg-20 text-body mb-2 mb-lg-3 p-0">
                    <CardHeader>
                        <h2 className="text-20 text-body m-0">
                            <FormattedMessage defaultMessage="Fakturační údaje"/>
                        </h2>
                    </CardHeader>
                    <CardBody>
                        <Form innerRef={invoiceParamRef} onSubmit={nextStep}>
                            {userBasketData && userBasketData.canBuyToSchool && userBasketData.schools.length > 0 &&
                                <div className="d-flex flex-column flex-lg-row align-content-start mb-3">
                                    <FormGroup check inline>
                                        <Label check
                                               className={classNames('radio-label', {'active': invoiceType === 'person'})}>
                                            <Input type="radio" name="invoiceType" value="person"
                                                   checked={invoiceType === 'person'}
                                                   onChange={(el) => changeInvoiceType(el.target.value)}/>
                                            <FormattedMessage defaultMessage="Jednotlivec"/>
                                        </Label>
                                    </FormGroup>
                                    <FormGroup check inline>
                                        <Label check className={classNames('radio-label', {
                                            'active': invoiceType === 'company',
                                            'disabled': userBasketData && (!userBasketData.canBuyToSchool || userBasketData.schools.length === 0)
                                        })}>
                                            <Input type="radio" name="invoiceType" value="company"
                                                   disabled={userBasketData && (!userBasketData.canBuyToSchool || userBasketData.schools.length === 0)}
                                                   checked={invoiceType === 'company'}
                                                   onChange={(el) => changeInvoiceType(el.target.value)}/>
                                            <FormattedMessage defaultMessage="Škola / Organizace"/>
                                            <br/>
                                            <span className="subinfo">
                                    <FormattedMessage
                                        defaultMessage="(v případě, že bude licenci platit škola, vždy zvolte tuto možnost)"/>
                                </span>
                                        </Label>
                                    </FormGroup>
                                </div>}
                            {
                                invoiceType === 'person' &&
                                <Row className="border-top pt-5">
                                    <Col xs={12} lg={6}>
                                        <FormGroup>
                                            <Label for="invoiceName" className="fw-bold">
                                                <FormattedMessage defaultMessage="Jméno a příjmení: *"/>
                                            </Label>
                                            <Input type="text" name="invoiceName" required
                                                   onChange={() => setChangePersonData(true)}
                                                   invalid={showValidErrors && !invoiceParamRef.current.elements?.invoiceName?.checkValidity()}/>
                                        </FormGroup>
                                    </Col>
                                    <Col xs={12} lg={6}>
                                        <FormGroup>
                                            <Label for="invoiceEmail" className="fw-bold">
                                                <FormattedMessage defaultMessage="Email: *"/>
                                            </Label>
                                            <Input type="email" name="invoiceEmail" disabled required
                                                   invalid={showValidErrors && !invoiceParamRef.current.elements?.invoiceEmail?.checkValidity()}/>
                                        </FormGroup>
                                    </Col>
                                    <Col xs={12} lg={6}>
                                        <FormGroup>
                                            <Label for="invoicePhone" className="fw-bold">
                                                <FormattedMessage defaultMessage="Telefon: *"/>
                                            </Label>
                                            <Input type="text" name="invoicePhone" required
                                                   invalid={(showValidErrors || showValidPhoneErrors) && !invoiceParamRef.current?.elements?.invoicePhone?.checkValidity()}
                                                   onChange={() => setChangePersonData(true)} />
                                            {showValidPhoneErrors && !invoiceParamRef.current.elements?.invoicePhone?.checkValidity() && <FormFeedback>
                                                <FormattedMessage defaultMessage="Telefon musí být ve formátu +420 XXX XXX XXX"/>
                                            </FormFeedback>}
                                        </FormGroup>
                                    </Col>
                                </Row>
                            }

                            {
                                invoiceType === 'company' &&
                                <Row className="border-top pt-5">
                                    <Col xs={12} lg={6}>
                                        <FormGroup>
                                            <Label for="invoiceName" className="fw-bold">
                                                <FormattedMessage defaultMessage="Vyberte školu: *"/>
                                            </Label>
                                            <Input type="select" name="school" onChange={() => setChangePersonData(true)}>
                                                {userBasketData && userBasketData.schools.map((school) => (
                                                    <option value={school.id}>{school.name}</option>
                                                ))}
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            }

                        </Form>
                    </CardBody>
                </Card>

                <Card className="rounded-0 rounded-lg-20 mb-2 mb-lg-0 text-body">
                    <CardHeader>
                        <h2 className="text-20 text-body m-0">
                            <FormattedMessage defaultMessage="Způsob platby"/>
                        </h2>
                    </CardHeader>
                    <CardBody>
                        <Form innerRef={paymentMethodRef}>
                            {enabledPaymentMethod.indexOf('card') >= 0 && <FormGroup check>
                                <Label check
                                       className={classNames('radio-label', {'active': paymentMethod === 'card'})}>
                                    <Input type="radio" name="paymentMethod" value="card"
                                           checked={paymentMethod === 'card'}
                                           onChange={() => setPaymentMethod('card')}/>
                                    <FormattedMessage defaultMessage="Kartou online"/>
                                </Label>
                            </FormGroup>}
                            {enabledPaymentMethod.indexOf('apple') >= 0 && <FormGroup check>
                                <Label check
                                       className={classNames('radio-label', {'active': paymentMethod === 'apple'})}>
                                    <Input type="radio" name="paymentMethod" value="apple"
                                           checked={paymentMethod === 'apple'}
                                           onChange={() => setPaymentMethod('apple')}/>
                                    <FormattedMessage defaultMessage="Apple Pay"/>
                                </Label>
                            </FormGroup>}
                            {enabledPaymentMethod.indexOf('google') >= 0 && <FormGroup check>
                                <Label check
                                       className={classNames('radio-label', {'active': paymentMethod === 'google'})}>
                                    <Input type="radio" name="paymentMethod" value="google"
                                           checked={paymentMethod === 'google'}
                                           onChange={() => setPaymentMethod('google')}/>
                                    <FormattedMessage defaultMessage="Google Pay"/>
                                </Label>
                            </FormGroup>}
                            {enabledPaymentMethod.indexOf('gratis') >= 0 && <FormGroup check>
                                <Label check
                                       className={classNames('radio-label', {'active': paymentMethod === 'gratis'})}>
                                    <Input type="radio" name="paymentMethod" value="gratis"
                                           checked={paymentMethod === 'gratis'}
                                           onChange={() => setPaymentMethod('gratis')}/>
                                    <FormattedMessage defaultMessage="Zdarma"/>
                                </Label>
                            </FormGroup>}
                            {enabledPaymentMethod.indexOf('invoice') >= 0 && invoiceType === 'company' &&
                                <FormGroup check>
                                    <Label check
                                           className={classNames('radio-label', {'active': paymentMethod === 'invoice'})}>
                                        <Input type="radio" name="paymentMethod" value="invoice"
                                               checked={paymentMethod === 'invoice'}
                                               onChange={() => setPaymentMethod('invoice')}/>
                                        <FormattedMessage defaultMessage="Platba na fakturu"/>
                                    </Label>
                                </FormGroup>}
                        </Form>
                    </CardBody>
                </Card>
            </Col>
            <Col xs={{size: 12, order: 1}} lg={6} xxl={4} className="p-0 px-lg-2">
                <Card className="rounded-0 rounded-lg-20 text-body">
                    <CardHeader>
                        <h2 className="text-20 text-body m-0">
                            <FormattedMessage defaultMessage="Máte vybráno"/>
                        </h2>
                    </CardHeader>
                    <CardBody>
                        {
                            basketData && basketData.items.map((item) => (
                                <Row className="border-top py-4" key={item.id}>
                                    <Col xs={2} className="fw-bold text-14">
                                        {item.amount}x
                                    </Col>
                                    <Col xs={8} className="fw-bold text-14">
                                        {item.name}
                                    </Col>
                                    <Col xs={2}>
                                        <Button color="close" className="p-0" size="sm"
                                                onClick={() => removeFromBasket(item.id)}></Button>
                                    </Col>
                                </Row>
                            ))
                        }
                        <Row className="border-top py-4">
                            {
                                basketData && !basketData.discountCode && !showDiscountForm &&
                                <Col xs={12} className="text-center">
                                    <Button color="link" className="fw-normal text-blue text-underline"
                                            onClick={() => setShowDiscountForm(true)}>
                                        <FormattedMessage defaultMessage="Použít slevový kód"/>
                                    </Button>
                                </Col>
                            }
                            {
                                showDiscountForm && <Col xs={12} className="text-center py-1">
                                    <Form className="d-flex flex-column flex-lg-row" onSubmit={addDiscountCode}>
                                        <FormGroup>
                                            <Input type="text" name="discountCode" id="discountCode"
                                                   placeholder="Zadejte slevový kód" innerRef={discountCodeInput}/>
                                        </FormGroup>
                                        <Button color="-blue-submit" onClick={addDiscountCode}>
                                            <FormattedMessage defaultMessage="Použít kód"/>
                                        </Button>
                                    </Form>
                                    {
                                        invalidDiscountCode && <div className="text-center">
                                            <img src={iconStop} className="h-20px"/>
                                            <span className="text-14 ps-3">
                                            <FormattedMessage defaultMessage="Neplatný slevový kód"/>
                                        </span>
                                        </div>
                                    }
                                </Col>
                            }
                            {
                                basketData && basketData.discountCode && <>
                                    <Col xs={2} className="fw-bold text-14">
                                        1x
                                    </Col>
                                    <Col xs={8} className="fw-bold text-14">
                                        <FormattedMessage defaultMessage="Slevový kód"/>(<FormattedNumber
                                        value={basketData.discount}
                                        style="currency"
                                        currency="CZK"/>)
                                    </Col>
                                    <Col xs={2}>
                                        <Button color="close" size="sm" className="p-0"
                                                onClick={removeDiscountCode}></Button>
                                    </Col>
                                </>
                            }
                        </Row>
                        <Row className="border-top py-3">
                            <Col xs={12} className="text-center">
                                <span className="fw-bolder text-12 text-uppercase"><FormattedMessage
                                    defaultMessage="Celkem zaplatíte"/></span>
                                <br/>
                                <span className="text-30 fw-bold">
                            <FormattedNumber
                                value={basketData ? basketData.price : 0}
                                style="currency"
                                currency="CZK"/>
                        </span>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Col>
            <Col xs={{size: 12, order: 3}} className="pt-5 text-center p-0 px-lg-2">
                <Button color="-blue" className="mt-0 mt-lg-3 text-17" onClick={nextStep}>
                    <strong className="pe-2"><FormattedMessage defaultMessage="Pokračovat v objednávce"/></strong>
                    <img src={iconArrow}/>
                </Button>
                {showError && <Alert color="danger">
                    <FormattedMessage defaultMessage="Při odeslání objednávky došlo k chybě"/>
                </Alert>}
            </Col>
        </Row>
    );

};

BasketPage.propTypes = {
    config: PropTypes.object.isRequired
};

BasketPage.defaultProps = {}

export default BasketPage;
